import { AxiosResponse } from "axios";

export const downloadFile = ({ res, type, defaultFilename }: { res: AxiosResponse<Blob>, type?: string, defaultFilename: string }) => {
  const contentDisposition = res.headers['content-disposition'];
  let filename = defaultFilename;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^;"]+)"?/);
    if (match) filename = match[1];
  }
  const contentType =
    !type ? res.headers['content-type'] :
      type === 'pdf'
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  
  // ensure Blob type is string | undefined (headers may be null)
  const blobType: string | undefined = typeof contentType === 'string' ? contentType : undefined;
  const url = window.URL.createObjectURL(
    new Blob([res.data], { type: blobType })
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}; 